import React from "react";
import { VestingContainer } from "../../../containers";

const Vesting = (props) => {
  return <VestingContainer {...props} />;
};

export default Vesting;
